import React from 'react'
import styled from 'styled-components'
import {Input} from "../../common/components/Input"
import SubmitButton from './SubmitButton'
import * as actions from "../../completion/actions"
import {connect} from "react-redux"
import Text from "../../common/components/Text";

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

const PhoneInput = Input.extend.attrs({
  placeholder: 'Phone number'
})`
  width: ${150/18}rem;
`

const EmailInput = Input.extend.attrs({
  placeholder: 'Email address'
})`
  margin: ${4/18}rem 0 ${10/18}rem;
  width: ${260/18}rem;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const TermsText = Text.extend.attrs({size: "bodyMain", color: 'neutral'})`
  display: block;
  margin-top: 24px;
  margin-bottom: 3rem;
`

const EmailPhoneResponse = ({email, phone, emailChange, phoneChange, onSubmit, brand}) => (
  <div>
    <Wrapper>
    <EmailInput value={email} onChange={emailChange} />
    <PhoneInput className="phone-mask" value={phone} onChange={phoneChange} />
    {brand && brand.terms && <TermsText>{brand.terms}</TermsText>}
  </Wrapper>
    {phoneRegex.test(phone.replace(/\D/g,'')) && emailRegex.test(email) && <SubmitButton onSubmit={() => onSubmit(brand.name)} />}
  </div>
)

const mapStateToProps = (state) => ({
  email: state.completion.email,
  phone: state.completion.phoneNumber,
  brand: state.brand
})

const mapDispatchToProps = (dispatch) => ({
  emailChange: (e) => dispatch(actions.setEmail(e.target.value.trim())),
  phoneChange: (e) => dispatch(actions.setPhoneNumber(e.target.value.trim())),
  onSubmit: (brandName) => dispatch(actions.emailPhoneSubmit(brandName))
})

const EmailPhoneResponseWrapper = connect(mapStateToProps, mapDispatchToProps)(EmailPhoneResponse)

export {EmailPhoneResponseWrapper as default, EmailPhoneResponse}



// WEBPACK FOOTER //
// ./assets/interview/components/EmailPhoneResponse.js